import { gql } from '@apollo/client'

const OPERATION_CREATE_COUPON = gql`
  mutation createCoupon(
    $sf_id: String!
    $type: String!
    $amount: Int
    $starts_at: String
    $ends_at: String
    $max_usage: Int
    $description: String
    $phone_number: String
    $with_ran_access: Boolean
    $send_sms: Boolean
    $offer_id: Int
  ) {
    coupons: createCoupon(
      sf_id: $sf_id
      type: $type
      amount: $amount
      starts_at: $starts_at
      ends_at: $ends_at
      max_usage: $max_usage
      description: $description
      phone_number: $phone_number
      with_ran_access: $with_ran_access
      send_sms: $send_sms
      offer_id: $offer_id
    ) {
      ... on Coupon {
        id
        site {
          name
        }
        code
        description
        number_of_devices
        offer {
          name
        }
        used
        expired
        valid
        first_provisioning_date
        created_by
        creator_firstname
        creator_lastname
        created_at
        validity_period
        phone
        starts_at
        ends_at
        type  
      }
    }
  }
`
export const OPERATION_SEND_SMS = gql`
  mutation sendSMS($id: Int!) {
    sendSMS(id: $id) {
      status
    }
  }
`

export const OPERATION_UPDATE_COUPON = gql`
  mutation updateCoupon($id: Int!, $phone_number: String, $description: String!) {
    result: updateCoupon(id: $id, phone_number: $phone_number, description: $description) {
      id
      phone
      description
    }
  }
`

export const OPERATION_DISABLE_COUPONS = gql`
  mutation disableCoupon($id: Int!) {
    disableCoupon(id: $id) {
      status
    }
  }
`

export default OPERATION_CREATE_COUPON
